import DashboardTopbar from "@/components/DashboardTopbar"
import { usePuzzle } from "@/hooks/usePuzzle"
import ActionBar from "./ActionBar"
import { useEffect, useState } from "react"
import SolutionBoard from "./SolutionBoard"
import { GameMovesProvider } from "@/hooks/useGameMoves"
import Sidebar from "./Sidebar"
import { getNextTurn } from "@/utils/turn"
import { emptyFen } from "@/constants"
import FrozenBoard from "./FrozenBoard"
import PuzzleBoard from "./PuzzleBoard"

export type ActiveTab = 0 | 1 | 2 | 3

const PuzzleScreen = ({ isOwner }: { isOwner: boolean }) => {
  const { title, start, moves } = usePuzzle()
  const [activeTab, setActiveTab] = useState<ActiveTab>(0)

  const startIsEmpty = !start || start === emptyFen

  useEffect(() => {
    if (!startIsEmpty && (!moves || moves?.length === 0)) setActiveTab(1)
    if (moves && moves.length > 0) setActiveTab(2)
  }, [startIsEmpty, moves])

  const pageTitle = !isOwner ? "ChessDrop Puzzles" : (title ?? "Draft puzzle")

  const autoplaySide = isOwner
    ? undefined
    : start
      ? getNextTurn(start)
      : undefined

  return (
    <>
      <DashboardTopbar
        title={pageTitle}
        backHref={isOwner ? "/puzzles/me" : "/puzzles"}
      >
        {isOwner && <ActionBar />}
      </DashboardTopbar>

      <GameMovesProvider
        mode={isOwner ? "draft" : "replicate"}
        autoplaySide={autoplaySide}
      >
        <main className="relative z-10 flex flex-1 flex-col min-[1500px]:pr-[500px] lg:pr-[335px] xl:pr-96">
          <div className="relative flex flex-1 flex-col items-center justify-center bg-white px-6 lg:px-8">
            <div className="z-30 w-full max-w-[500px] py-12">
              {isOwner && activeTab === 0 ? (
                <PuzzleBoard />
              ) : isOwner && activeTab === 2 ? (
                <FrozenBoard />
              ) : (
                <SolutionBoard />
              )}
            </div>
          </div>

          <Sidebar
            isOwner={isOwner}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </main>
      </GameMovesProvider>
    </>
  )
}

export default PuzzleScreen
